export default "__VITE_ASSET__g3DV8Uba__"